import React from 'react';
import PropTypes from 'prop-types';
import APQRCode from 'apex-web/lib/components/common/APQRCode/APQRCode';
import APIcon from 'apex-web/lib/components/common/APIcon';
import Spinner from 'apex-web/lib/components/common/Spinner/Spinner';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';
import copyToClipboard from 'apex-web/lib/helpers/clipboardHelper';
import destinationTagHelper from 'apex-web/lib/helpers/destinationTagHelper';
import { InnerSelect } from '../../common/APSelect';
import './ReceiveAddress.css';

const bemClasses = getBEMClasses('receive-address');

class ReceiveAddressComponent extends React.Component {
  state = {
    selectedAccountProviderId: null
  };
  componentWillMount() {
    const { selectDepositProduct, product } = this.props;
    selectDepositProduct(product.ProductId);
  }

  handleSelectAccountProvider = accountProviderId => {
    const { fetchAccountProviderDepositInfo, product } = this.props;

    if (!accountProviderId) {
      return this.setState({ selectedAccountProviderId: accountProviderId });
    }

    fetchAccountProviderDepositInfo(product.ProductId, accountProviderId);
    this.setState({ selectedAccountProviderId: accountProviderId });
  };

  render() {
    const {
      deposit: { depositInfo: addressList },
      deposit: { isLoading, error, templateTypes },
      product,
      showSnack,
      WalletsDisabledMessage
    } = this.props;
    const { selectedAccountProviderId } = this.state;

    // Protocol prefix for the QR Code, lowercase name with no spaces.
    const depositType = product.ProductFullName.toLowerCase().replace(
      /\W/g,
      ''
    );

    const templateTypeOptions = [
      { value: '', label: 'Select an option', disabled: true, selected: true },
      ...templateTypes.map(template => ({
        value: template.AccountProviderId,
        label: template.AccountProviderName
      }))
    ];

    let selectedAddress;

    if (!isLoading && addressList.length) {
      selectedAddress = addressList[addressList.length - 1];
    }

    const { address, dt, memo } = destinationTagHelper(selectedAddress);

    return (
      <section className={bemClasses()}>
        {templateTypes.length ? (
          <InnerSelect
            name="AccountProvider"
            customClass={bemClasses('account-provider-select')}
            label={this.context.t(
              'Select an option to continue the deposit process'
            )}
            onSelect={this.handleSelectAccountProvider}
            options={templateTypeOptions}
          />
        ) : (
          <div>{this.context.t('No account providers are configured')}</div>
        )}
        {selectedAddress &&
          selectedAccountProviderId && (
            <React.Fragment>
              <p className={bemClasses('description')}>
                {this.context.t('Scan this QR code to receive funds:')}
              </p>
              <div className={bemClasses('qr-code')}>
                <APQRCode value={`${depositType}:${selectedAddress}`} />
              </div>
              <p className={bemClasses('copy-address-text')}>
                {this.context.t('Or copy this address:')}
              </p>
              <div
                className={bemClasses('copy-address-payload')}
                onClick={() => {
                  copyToClipboard(address);
                  showSnack({
                    id: 'RECEIVE_ADDRESS_COPY',
                    text: this.context.t(
                      'The address has been copied to the clipboard.'
                    )
                  });
                }}>
                <span className={bemClasses('address')}>{address}</span>
                <APIcon name="copy" customClass={bemClasses('copy-icon')} />
              </div>
              {dt && (
                <div
                  onClick={() => {
                    copyToClipboard(dt);
                    showSnack({
                      id: 'RECEIVE_ADDRESS_COPY',
                      text: this.context.t(
                        'The destination tag has been copied to the clipboard.'
                      )
                    });
                  }}>
                  <p className={bemClasses('destination-tag-text')}>
                    {this.context.t('Be sure to include this destination tag:')}
                  </p>
                  <span className={bemClasses('address')}>{dt}</span>
                  <APIcon name="copy" customClass={bemClasses('copy-icon')} />
                </div>
              )}
              {memo && (
                <div
                  onClick={() => {
                    copyToClipboard(memo);
                    showSnack({
                      id: 'RECEIVE_ADDRESS_COPY',
                      text: this.context.t(
                        'The memo tag has been copied to the clipboard.'
                      )
                    });
                  }}>
                  <p className={bemClasses('memo-tag-text')}>
                    {this.context.t('Be sure to include this memo tag:')}
                  </p>
                  <span className={bemClasses('address')}>{memo}</span>
                  <APIcon name="copy" customClass={bemClasses('copy-icon')} />
                </div>
              )}
            </React.Fragment>
          )}
        {isLoading && (
          <Spinner
            text={this.context.t('Loading url...')}
            customClass={bemClasses}
          />
        )}
        {WalletsDisabledMessage ? (
          <span className={bemClasses('error')}>
            {this.context.t(WalletsDisabledMessage)}
          </span>
        ) : (
          error && (
            <span className={bemClasses('error')}>{this.context.t(error)}</span>
          )
        )}
      </section>
    );
  }
}

ReceiveAddressComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    templateTypes: [],
    template: {},
    isLoading: false,
    error: '',
    depositInfo: {},
    depositStatus: {}
  },
  product: {}
};

ReceiveAddressComponent.propTypes = {
  product: PropTypes.object,
  deposit: PropTypes.shape({
    templateInfo: PropTypes.object.isRequired,
    templateTypes: PropTypes.object.isRequired,
    template: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
    product: PropTypes.number,
    depositInfo: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
      .isRequired,
    depositStatus: PropTypes.shape({
      success: PropTypes.bool,
      RequestCode: PropTypes.string
    }).isRequired
  })
};

ReceiveAddressComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default ReceiveAddressComponent;
